import { useEffect, useState } from "react";

type Listener = (open: boolean) => void;
const listeners = new Set<Listener>();
let currentOpen = false;

export const startProjectStore = {
  open() {
    currentOpen = true;
    listeners.forEach((l) => l(true));
  },
  close() {
    currentOpen = false;
    listeners.forEach((l) => l(false));
  },
  get isOpen() {
    return currentOpen;
  },
};

export function useStartProjectSheet() {
  const [open, setOpen] = useState(currentOpen);
  useEffect(() => {
    listeners.add(setOpen);
    return () => {
      listeners.delete(setOpen);
    };
  }, []);
  return {
    open,
    openSheet: startProjectStore.open,
    closeSheet: startProjectStore.close,
  };
}
